<template>
  <v-data-table dense disable-pagination hide-default-footer fixed-header
                height="100%"
                style="height: 100%; width: 100%; position: absolute; overflow-y: auto"
                ref="datatable"
                :headers="headers"
                :items="GET_FIND_DATA"
                class="elevation-0"
                item-key="ID"
  >
    <template v-slot:item="{item}">
      <tr>
        <td>{{ item.ID }}</td>
        <td>{{ item.ParticipantName }}</td>
        <td>{{ new Date(item.WhenFinished).toLocaleString() }}</td>
        <td>
          <v-btn @click="handleResultClick(item.ID)" icon>
            <v-icon color="primary">mdi-launch</v-icon>
          </v-btn>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
  import {mapActions, mapMutations, mapGetters} from 'vuex'

  export default {
    name: 'MarkingAssessmentList',

    computed: {
      ...mapGetters(['GET_FIND_DATA', 'GET_FIND_ANSWERS']),
      refs() {
        console.dir(this.$refs.datatable);
        return this.$refs.datatable.$el.offsetHeight
      },
      tableHeight () {
        return this.$refs.datatable ? this.$refs.datatable.$el.offsetHeight : 500
      }
    },

    data() {
      return {
        pagination: {},
        headers: [
          {
            text: 'Result ID',
            align: 'left',
            sortable: true,
            value: 'ID'
          },
          {
            text: 'Candidate',
            align: 'left',
            sortable: true,
            value: 'ParticipantName'
          },
          {
            text: 'Finished',
            align: 'left',
            sortable: true,
            value: 'whenFinished'
          },
          {
            text: 'View',
            align: 'left'
          }
        ],
      }
    },

    methods: {
      ...mapActions(['FETCH_RESULT_ANSWERS', 'MARK_FETCH_ANSWER_DATA', 'MARK_FETCH_SCORING_TASKS_IN_RESULT']),
      ...mapMutations(['SET_SELECTED_ASSESSMENT', 'SET_TASK']),
      fetchResultAnswers(resultID) {
        this.FETCH_RESULT_ANSWERS(resultID)
      },
      async handleResultClick(result) {
        await this.MARK_FETCH_SCORING_TASKS_IN_RESULT(result);
        await this.SET_TASK(null);
        await this.$router.push({
          name: "mark",
          params: {
            noFetch: true
          }
        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
